/**
 * student
 */
export default {
    name: 'student',
    path: '/student',
    meta: {},
    component: () => import('@/views/student/Home'),
    redirect: '/student/index',
    children: [
        {
            name: 'studentIndex',
            path: 'index',
            meta: {},
            component: () => import('@/views/student/Index'),
        },
    ],
};
